import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Connects to data-controller="event-types--select-timezone"
export default class extends Controller {
  handle({ target }) {
    let url = new URL(window.location.href);

    let params = new URLSearchParams(url.search);
    params.set("timezone", target.value);
    url.search = params.toString();

    Turbo.visit(url.toString());
  }
}
